import { AxiosResponse } from "axios";
import { client } from "./axios";
import { readCache } from "./readCache";
import { queryKey, ReadCacheOptions } from "./queryCache";

export const cachedGet = <T = unknown>(
  url: string,
  params?: object | null,
  options?: ReadCacheOptions,
) =>
  readCache.get<AxiosResponse<T>>(
    queryKey(url, params),
    () => client.get<T>(url, { params }),
    options,
  );

export const peekCachedGet = <T = unknown>(
  url: string,
  params?: object | null,
) => readCache.peek<AxiosResponse<T>>(queryKey(url, params));

export const invalidateReadCache = (tags?: string[]) =>
  readCache.invalidate(tags);
